import { Card, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function Details({
  isbn,
  title,
  authors,
  publicationYear,
  summary,
  coverImageUrl,
}: Readonly<{
  isbn: string;
  title: string;
  authors: string[];
  publicationYear?: number;
  summary?: string;
  coverImageUrl?: string;
}>) {
  const { t } = useTranslation();

  return (
    <>
      <Stack
        direction='column'
        sx={{
          paddingX: 2,
          paddingTop: { xs: 2, lg: 3 },
          paddingBottom: { xs: 0, lg: 1.5 },
        }}
      >
        <Typography variant='h3' sx={{ paddingBottom: 0.5 }}>
          {title}
        </Typography>
        <Typography component='p' variant='caption' sx={{ paddingBottom: 0.5 }}>
          {authors.join(' – ')}
        </Typography>
        {publicationYear && (
          <Typography component='p' variant='caption' color='text.secondary'>
            {t('readingView.bookDetails.publicationYear', {
              year: publicationYear,
            })}
          </Typography>
        )}
        <Typography component='p' variant='caption' color='text.secondary'>
          {t('readingView.bookDetails.isbn')} {isbn}
        </Typography>
      </Stack>

      {summary && (
        <Stack
          direction='column'
          sx={{ paddingX: 2, paddingTop: { xs: 1.5, lg: 3 }, paddingBottom: 2 }}
        >
          <Typography
            component='p'
            variant='body2'
            color='text.secondary'
            dangerouslySetInnerHTML={{ __html: summary }}
          />
        </Stack>
      )}

      {coverImageUrl && (
        <Stack
          direction='row'
          sx={{ paddingX: 2, paddingTop: 2, paddingBottom: 3 }}
          gap={3}
        >
          <Card sx={{ maxWidth: '100%', width: '100%', height: 'auto' }}>
            <img
              src={coverImageUrl}
              alt={`${t('readingView.bookDetails.coverImageAlt')} ${title}`}
              style={{ display: 'block', width: '100%', height: 'auto' }}
            />
          </Card>
        </Stack>
      )}
    </>
  );
}
